/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sbb-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'sbb-badge',
    '[class.sbb-badge-active]': 'active',
    '[attr.aria-label]': 'ariaLabel',
  },
})
export class SbbBadge {
  /**
   * The badge has two status, but, basically its common usage is in active state (see {@link TabsComponent}).
   * Anyway this property can change its status, and so it will change the styling.
   */
  @Input() active: boolean = true;

  @Input('aria-label') ariaLabel: string | null = null;
}
